import React from 'react';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import SortDropdown from '../../../components/sort-dropdown/SortDropdown';
import useGenieMessagesSort from '../../../hooks/useGenieMessagesSort';

import scss from './SortField.module.scss';

function SortField({ sort, onSortChange, disabled }) {
  const { t } = useTranslation('genie');

  const sortOptions = useGenieMessagesSort();

  const handleChangeSort = ({ sort, direction }) => {
    const getSortValue = sortOptions.find(({ value }) => value === sort)?.getSortValue;

    onSortChange({ sort, direction, getSortValue });
  };

  return (
    <div className={scss.wrapper}>
      <WithLabel label={`${t('sort')}:`} variant={LABEL_STYLES.ROW} isBold maxWidth={200}>
        <SortDropdown
          options={sortOptions}
          sort={sort?.sort}
          direction={sort?.direction}
          onChange={handleChangeSort}
          disabled={disabled}
          closeOnApply
        />
      </WithLabel>
    </div>
  );
}

export default SortField;
